import { Injectable } from '@angular/core';
import { GetTimestampFromTime } from '@dave/types';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { concatMap, EMPTY, firstValueFrom, from, mergeMap, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { isNotNullOrUndefined } from '../../../helper/helper';
import { AppGatewayService } from '../../services/app-gateway.service';
import { DaveActions } from '../actions/actions';
import { BaseActionTypes } from '../actions/base.actions';
import { State } from '../index';
import { MultipleGabeImportJobsActionTypes } from '../actions/multiple-gabe-import-jobs.actions';
import { MultipleGabeImportJobsEntityFromBackend } from '../../entities/multiple-gabe-import-jobs.entity';
import { getMultipleGabeImportJobsDictionary } from '../selectors/multiple-gabe-import-jobs.selector';


enum ErrorCodes {
    Load = 'UGL Importe Abrufen fehlgeschlagen',
}

@Injectable()
export class MultipleGabeImportJobsEffects {

    LoadMultipleGabeImportJobs = createEffect(() => {
        return this.actions$.pipe(
            ofType(MultipleGabeImportJobsActionTypes.Load),
            switchMap(({ Payload }) => {
                const requestPayload = isNotNullOrUndefined(Payload?.updatedSince) ? { UpdatedSince: Payload.updatedSince } :{};


                return from(this.gatewayService.Request({ GabeGetMultipleGabeImportJobs: requestPayload })).pipe(
                    mergeMap((res) => {
                        if (Object.keys(res?.Errors || {}).length === 0) {
                            if (!isNotNullOrUndefined(Payload.updatedSince)) {
                                return of(
                                    MultipleGabeImportJobsActionTypes.UpdateAll({
                                        Payload: res.GabeGetMultipleGabeImportJobs.MultipleGabeImportJobs.map((val) => MultipleGabeImportJobsEntityFromBackend(val)),
                                        updateLatestUpdatedAt: true,
                                    }),
                                );
                            } else if (res.GabeGetMultipleGabeImportJobs.MultipleGabeImportJobs.length) {
                                return from(firstValueFrom(this.store$.select(getMultipleGabeImportJobsDictionary))).pipe(
                                    mergeMap((MultipleGabeImportJobss) => {
                                        const filteredMultipleGabeImportJobss = res.GabeGetMultipleGabeImportJobs.MultipleGabeImportJobs.filter((MultipleGabeImportJobs) => {
                                            const fromState = MultipleGabeImportJobss[MultipleGabeImportJobs.Id];
                                            return !fromState || GetTimestampFromTime(fromState.UpdatedAt).toString() !== MultipleGabeImportJobs.UpdatedAt;
                                        });

                                        if (filteredMultipleGabeImportJobss.length) {
                                            return of(
                                                MultipleGabeImportJobsActionTypes.UpdateMany({
                                                    Payload: filteredMultipleGabeImportJobss.map((val) => MultipleGabeImportJobsEntityFromBackend(val)),
                                                    updateLatestUpdatedAt: true,
                                                }),
                                            );
                                        } else {
                                            return EMPTY;
                                        }
                                    }),
                                );
                            }
                            return EMPTY;
                        } else {
                            throw res.Errors;
                        }
                    }),
                    catchError((err) =>
                        of(
                            BaseActionTypes.ErrorAction({
                                Payload: {
                                    ToasterMessage: ErrorCodes.Load,
                                    Err: err,
                                },
                            }),
                        ),
                    ),
                );
            }),
        );
    });

    constructor(private actions$: Actions<DaveActions>, private store$: Store<State>, private gatewayService: AppGatewayService) {}
}
